"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onAuthRefresh;

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _Countdown = _interopRequireDefault(require("../Countdown"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function onAuthRefresh(_ref) {
  var authTimestamp = _ref.authTimestamp,
      isAuthTimerFinished = _ref.isAuthTimerFinished;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['wrapper'],
    "data-locator": 'authTime'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-crose'),
    "data-locator": 'authTime.icon'
  }), /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
    level: 3,
    className: _defaultModule["default"]['title'],
    "data-locator": 'authTime.title'
  }, "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E", /*#__PURE__*/_react["default"].createElement("br", null), "\u043F\u043E\u043F\u044B\u0442\u043E\u043A \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438"), /*#__PURE__*/_react["default"].createElement(_Countdown["default"], {
    interval: 1000,
    eventTime: authTimestamp,
    finished: isAuthTimerFinished,
    label: 'Попробуйте еще раз через',
    size: 'big',
    locator: 'nextAuthTime'
  }));
}